import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import {
  PercentualShipping,
  RegularBenefitVariant,
} from '../../../../../../../typings'
import { validationShippingVariantSuite } from '../../../../../../ShippingVariantSelector/validation'
import { messages } from './messages'

export function validationSuitePercentualShipping(intl: IntlShape) {
  return create((props: PercentualShipping) => {
    const { value, type } = props
    const { $t } = intl
    const { validation } = messages

    omitWhen(type !== RegularBenefitVariant.PercentualShipping, () => {
      omitWhen(value === undefined, () => {
        test('value', $t(validation.greaterThan, { value: 0 }), () => {
          enforce(value).greaterThan(0)
        })

        test('value', $t(validation.lessThanOrEquals, { value: 100 }), () => {
          enforce(value).lessThanOrEquals(100)
        })
      })

      test('value', $t(validation.required), () => {
        enforce(value).isNotEmpty()
      })

      validationShippingVariantSuite(intl)(props as PercentualShipping)
    })
  })
}
